import { api } from '@/services/backend/http-client';
import { MobilePKILoginResponseType, MobilePKIVerificationResponseType, UserRegistrationType } from './types';

export const registerAccount = async (request: UserRegistrationType): Promise<void> => {
  const response = await api.post(`/account/register`, request);
  return response.data;
};
export const forgotPassword = async (email: string): Promise<void> => {
  const response = await api.post(`/account/password-reset`, { email });
  return response.data;
};

export const resendEmailVerification = async (email: string): Promise<void> => {
  const response = await api.post(`/account/resend-verification`, { email });
  return response.data;
};

export const initiateMobilePKILogin = async (mobileNumber: string): Promise<MobilePKILoginResponseType> => {
  const response = await api.post<MobilePKILoginResponseType>('/account/mpki-login/signature', {
    mobileNumber,
  });
  return response.data;
};

export const verifyMobilePKILogin = async (transactionId: string): Promise<MobilePKIVerificationResponseType> => {
  const response = await api.get<MobilePKIVerificationResponseType>(`/account/mpki-login/signature/${transactionId}`);
  return response.data;
};
